<template>
	<div class="home">
		<!--		<img alt="Vue logo" src="../assets/logo.png">-->
		<!--		<HelloWorld msg="Welcome to Your Vue.js App"/>-->
		<video class="bg-video" src="/footage/intro.mp4" autoplay muted loop playsinline></video>
		<Compass v-on:click="startAudio"></Compass>
		<div class="disclaimer-wrapper">
			<!--			<p class="mobile-disclaimer">This page is best viewed in Kasimpasa, accompanied by a clan of Tinerci Paragons</p>-->
			<div class="footer-mobile">
				<div style="display: flex;flex-direction: column;width: 60vw; font-size: 20px;">
					<div>Parladı, Arkamı Döndüm</div>
					<hr style="width: 100%;border: 1px solid rgba(255,255,255,0.49);border-bottom: none;">
					<div>It Flashed, I Turned Away</div>
				</div>
				<div style="display: flex;flex-direction: row;width: 60vw;justify-content: space-between;font-size: 12px;margin-top: 30px;">
					<div>bilgisayardan izleyin</div>
					<div style="width: 20px;"></div>
					<div>see on computer</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	import HelloWorld from '@/components/HelloWorld.vue'
	import Compass from "../components/Compass"

	export default {
		name: 'home',
		components: {
			Compass,
			HelloWorld
		},
		methods: {
			startAudio: function () {

			}
		}
	}
</script>

<style scoped>

	@font-face {
		font-family: 'hkgroteskmed';
		src: url('/fonts/HKGrotesk-Medium.ttf');
	}

	.bg-video {
		top: 0;
		left: 0;
		position: absolute;
		object-fit: cover;
		width: 100%;
		height: 100%;
		z-index: -2;
	}

	.disclaimer-wrapper {
		display: none;

	}

	.footer-mobile {
		display: flex;
		color: white;
		flex-direction: column;
		position: absolute;
		bottom: 30px;
		left: 0;
		width: 100%;
		justify-content: center;
		align-items: center;
		font-family: 'hkgroteskmed';
	}


	.footer-mobile > div {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 5px;
	}

	@media (hover: none) {
		.disclaimer-wrapper {
			display: flex;
			justify-content: center;
			align-items: center;
			text-align: center;
			color: white;
			font-size: 30px;
		}
	}
</style>